import { Flex, IconButton, Text } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

interface Props {
  quantity: number;
  onChange: (quantity: number) => void;
}

const QuantityPicker = ({ quantity, onChange }: Props) => {
  const [value, setValue] = useState(quantity);

  const handleQuantityChange = useCallback(
    (type: "inc" | "dec") => {
      let newValue = value;
      if (type === "inc") {
        newValue = value + 1;
      } else {
        newValue = Math.max(value - 1, 1);
      }
      setValue(newValue);
      onChange(newValue);
    },
    [onChange, value]
  );

  const handleDecrement = useCallback(() => {
    handleQuantityChange("dec");
  }, [handleQuantityChange]);

  const handleIncrement = useCallback(() => {
    handleQuantityChange("inc");
  }, [handleQuantityChange]);

  return (
    <Flex gap={4} alignItems="center">
      <IconButton size="2xs" onClick={handleDecrement}>
        <FaMinus />
      </IconButton>
      <Text>{value}</Text>
      <IconButton size="2xs" onClick={handleIncrement}>
        <FaPlus />
      </IconButton>
    </Flex>
  );
};

export default QuantityPicker;
